/* eslint-disable */
import React,{useEffect , useRef} from "react";
// import { Helmet } from "react-helmet";
import { InjectedConnector } from '@web3-react/injected-connector';

import { truncateAccount } from "../../utils/format.js";
import { useContract } from "../../hooks/useContract.js";
import { useEagerConnect } from '../../hooks/useEagerConnect.js'
import { useReadContract } from "../../hooks/useRead.js";

import $ from 'jquery';

import Header from "../Inc/Header";
import Footer from "../Inc/Footer";

import bannerimg1 from "../../images/hone-bg2.png"
import characterhome1 from "../../images/character-home1.png"
import bannerimg2 from "../../images/home-img1.svg"
import logo from "../../images/logo.png"

import bodycontimg2 from "../../images/home-bg3.png"
import bodycontimg3 from "../../images/home-img2.png"
import bodycontimg4 from "../../images/home-img3.png"
import bodycontimg5 from "../../images/home-img4.svg"

import titleimg from "../../images/title-img.svg"

import bodycontimg6 from "../../images/home-img5.png"
import bodycontimg7 from "../../images/home-img6.png"
import bodycontimg8 from "../../images/home-img7.png"

import bodycontimg9 from "../../images/home-img8.png"
import bodycontimg10 from "../../images/home-img9.png"

import bodycontimg11 from "../../images/home-img10.png"
import bodycontimg12 from "../../images/home-img11.png"
import bodycontimg13 from "../../images/home-img12.png"

import bodycontimg14 from "../../images/home-img14.png"
import bodycontimg15 from "../../images/home-img15.png"

import bodycontimg16 from "../../images/home-img16.png"

import menulogo from "../../images/menu-logo.svg"

import teamimg1 from "../../images/alden.png"
import teamimg2 from "../../images/justin.png"
import teamimg3 from "../../images/kent.png"
import teamimg4 from "../../images/zen.png"

import teamimg5 from "../../images/yee.png"
import teamimg6 from "../../images/yau.png"
import teamimg7 from "../../images/jason.png"
import teamimg8 from "../../images/cpt.png"

import teamimg9 from "../../images/Kendrick Wong.png"
import teamimg10 from "../../images/Jared.png"
import teamimg11 from "../../images/Giulio Xiloyannis.png"
import teamimg12 from "../../images/Joshua.png"
import teamimg13 from "../../images/Nat.png"

import mobmenuiocn from "../../images/mob-menu.svg"

import mobbg1 from "../../images/home-mob-bg1.png"
import mobbg2 from "../../images/home-mob-bg2.png"
import mobbg3 from "../../images/home-mob-bg3.png"
import mobbg4 from "../../images/home-mob-bg4.png"

import rarityimg1 from "../../images/rarity-img1.png"
import rarityimg2 from "../../images/rarity-img2.png"
import rarityimg3 from "../../images/rarity-img3.png"
import rarityimg4 from "../../images/rarity-img4.png"

import rarityimg5 from "../../images/rarity-img2-1.png"
import rarityimg6 from "../../images/rarity-img2-2.png"
import rarityimg7 from "../../images/rarity-img2-3.png"
import rarityimg8 from "../../images/rarity-img2-4.png"
import rarityimg9 from "../../images/rarity-img2-5.png"
import rarityimg10 from "../../images/rarity-img2-6.png"

import advocateimg1 from "../../images/advocate-img1.png"
import advocateimg2 from "../../images/advocate-img5.png"
import advocateimg3 from "../../images/advocate-img6.png"
import advocateimg4 from "../../images/advocate-img3.png"
// import advocateimg5 from "../../images/advocate-img2.png"
import advocateimg6 from "../../images/advocate-img4.png"

import lusiimg from "../../images/lusi-img.png"

// const scroll = new LocomotiveScroll();

// const anime = window.anime;
const TweenMax = window.TweenMax;
const Power4 = window.Power4;

const Home = (props) => {
    let container = useRef(null);

    const { account, activate } = useEagerConnect();
    const contract = useContract();

    const {currentSupply, waveMaxSupply} = useReadContract();

    const hasMetamask =
        typeof window !== 'undefined' &&
        !!window.ethereum &&
        !!window.ethereum.isMetaMask;

    const handleMetamaskClick = async () => {
      if (!account) {
        if (hasMetamask) {
          const injected = new InjectedConnector({
            supportedChainIds: [1, 4],
          });
          await activate(injected);
        } else {
          window.open('https://metamask.io/', '_blank');
        }
      }
    };


    // Wrap every letter in a span
    useEffect(() => {
        // new LocomotiveScroll({
        //     el: container,
        //     smooth: true,
        //     lerp: .06,
        //     multiplier: .5
        //  });

        //  const scroll = new LocomotiveScroll({
        //     el: document.querySelector('[data-scroll-container]'),
        //     smooth: true
        // });
        // console.log(textWrapper);


    // anime.timeline({loop: false})
    //   .add({
    //     targets: '.active .ml1',
    //     scale: [0.3,1],
    //     opacity: [0,1],
    //     translateZ: 0,
    //     easing: "easeOutExpo",
    //     duration: 10000,
    //     delay: (el, i) => 70 * (i+1)
    //   });


    function isMobileDevice() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };





  function sticktothetop() {
    var window_top = $(window).scrollTop();
        var top = $('#synopsis-sec').offset().top +450;
        if (window_top > top) {
            $('#synopsis-sec').addClass('active');
        } else {
            $('#synopsis-sec').removeClass('active');
        }
        var top = $('#dreamers-sec').offset().top;
        if (window_top > top) {
            $('#dreamers-sec').addClass('active');
        } else {
            $('#dreamers-sec').removeClass('active');
        }
        var top = $('#irregularities-sec').offset().top;
        if (window_top > top) {
            $('#irregularities-sec').addClass('active');
        } else {
            $('#irregularities-sec').removeClass('active');
        }
        var top = $('#roadmap-sec').offset().top -50;
        if (window_top > top) {
            $('#roadmap-sec').addClass('active');
        } else {
            $('#roadmap-sec').removeClass('active');
        }
        var top = $('#vision-sec').offset().top -200;
        if (window_top > top) {
            $('#vision-sec').addClass('active');
        } else {
            $('#vision-sec').removeClass('active');
        }
        var top = $('#team-sec').offset().top -250;
        if (window_top > top) {
            $('#team-sec').addClass('active');
        } else {
            $('#team-sec').removeClass('active');
        }
        var top = $('#rarity-sec').offset().top;
        if (window_top > top) {
            $('#rarity-sec').addClass('active');
        } else {
            $('#rarity-sec').removeClass('active');
        }
        var top = $('#advocate-sec').offset().top;
        if (window_top > top) {
            $('#advocate-sec').addClass('active');
        } else {
            $('#advocate-sec').removeClass('active');
        }
    }

function sticktothetopmobile() {
    var window_top = $(window).scrollTop();
        var top = $('#synopsis-sec').offset().top +200;
        if (window_top > top) {
            $('#synopsis-sec').addClass('active');
        } else {
            $('#synopsis-sec').removeClass('active');
        }
        var top = $('#dreamers-sec').offset().top -150;
        if (window_top > top) {
            $('#dreamers-sec').addClass('active');
        } else {
            $('#dreamers-sec').removeClass('active');
        }
        var top = $('#irregularities-sec').offset().top;
        if (window_top > top) {
            $('#irregularities-sec').addClass('active');
        } else {
            $('#irregularities-sec').removeClass('active');
        }
        var top = $('#roadmap-sec').offset().top -50;
        if (window_top > top) {
            $('#roadmap-sec').addClass('active');
        } else {
            $('#roadmap-sec').removeClass('active');
        }
        var top = $('#vision-sec').offset().top -200;
        if (window_top > top) {
            $('#vision-sec').addClass('active');
        } else {
            $('#vision-sec').removeClass('active');
        }
        var top = $('#team-sec').offset().top -250;
        if (window_top > top) {
            $('#team-sec').addClass('active');
        } else {
            $('#team-sec').removeClass('active');
        }

        var top = $('#rarity-sec').offset().top -200;
        if (window_top > top) {
            $('#rarity-sec').addClass('active');
        } else {
            $('#rarity-sec').removeClass('active');
        }
        var top = $('#advocate-sec').offset().top;
        if (window_top > top) {
            $('#advocate-sec').addClass('active');
        } else {
            $('#advocate-sec').removeClass('active');
        }
    }



    $(function() {
        if(isMobileDevice() == false){
            $(window).scroll(sticktothetop);
            sticktothetop();
        }

        if(isMobileDevice() == true){
            console.log("mobile");
            $(window).scroll(sticktothetopmobile);
            sticktothetopmobile();

        }

    });

    setTimeout(function() {
        $(".banner-sec").addClass("active");
    }, 300);

    $(".menu-sec ul li, .mob-menu ul.scrollspy").click(function(){
        $(".menu-sec ul li, .mob-menu ul.scrollspy").removeClass("current");
        $(this).addClass("current");

    });

    $("a.mob-menu-icon").click(function(){
        $(".mob-menu").addClass("current");
    });

    $("a.close-menu").click(function(){
        $(".mob-menu").removeClass("current");
    });
    $(".mob-menu ul.scrollspy li").click(function(){
        $(".mob-menu").removeClass("current");
    });
        // // Smooth scroll between elements.
        // $(".sm-scroll").on("click", function() {
        // var $this = $(this),
        //     href = $this.attr("href"),
        //     topY = $(href).offset().top

        // if ($("#body-inner").hasClass("smooth-scrollbar")) {
        //   var $scrollbar = Scrollbar.init(document.getElementById("scroll-container"));
        //   TweenMax.to($scrollbar, 2, {scrollTo: {y: topY, autoKill: true}, ease: Power4.easeInOut});
        // } else {
        //   TweenMax.to($(window), 2, {scrollTo: {y: topY, autoKill: true}, ease: Power4.easeInOut});
        // }

        // return false;
        // });




 }, []);

  return (
      <>
      <Header/>
    <div>
    {/* <div ref={scrollingContainer}> */}
    {/* <SmoothScroll> */}
        <div className="banner-sec" id="home-sec">
            <a href="#" className="wallet-but" onClick={handleMetamaskClick}>{account ? truncateAccount(account) : "Connect Wallet"}</a>
            <a href="#?" className="mob-menu-icon"><img src={mobmenuiocn} alt="img" /> </a>
            {/* <img className="img1" src={bannerimg1} alt="img" />     */}
            <picture>
                <source srcSet={mobbg1} media="(max-width: 767px)"/>
                <source srcSet={bannerimg1}/>
                <img className="img1" src={bannerimg1} alt="img" />
            </picture>
            <div className="wrapper">
              <div className="sec1" >
              <img className="img2" src={characterhome1} alt="img"/>

                <div className="zebra-wrap lt-sec">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                <div className="zebra-wrap rt-sec">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
              </div>
              <div className="sec2">
                <img className="main-logo" src={logo} alt="img" data-aos="fade-up" data-aos-delay="50"
                data-aos-duration="2000" />
                <div className="button-area1" data-aos="fade-up" data-aos-delay="100"
                data-aos-duration="2000">
                    {/* <a href="/mint" className="mint-but">Mint</a> */}
                    <a href="/mint" className="mint-but">Sold Out</a>
                    <span>
                    </span>
                </div>
                <h3 data-aos="fade-up" data-aos-delay="200"
                data-aos-duration="2000">10,000/10,000</h3>
{/* <h3 data-aos="fade-up" data-aos-delay="200" data-aos-duration="2000">{currentSupply ? currentSupply : "????"} / {waveMaxSupply ? waveMaxSupply : "????"}</h3> */}
              </div>
            </div>
        </div>


        <div className="body-cont1" id="synopsis-sec">
            {/* <img src={bodycontimg2} alt="" className="img1" /> */}
            <picture>
                <source srcSet={mobbg2} media="(max-width: 767px)"/>
                <source srcSet={bodycontimg2}/>
                <img src={bodycontimg2} alt="" className="img1" />
            </picture>
            <div className="title" data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500" data-aos-anchor-placement="top-bottom">
              <div className="img-sec">
                <h6 className="text">01</h6>
                <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                {/* <img className="img3" src={titleimg} alt="img" />      */}
              </div>
              <h2>
              synopsis
            </h2>
            </div>
            <div className="container-fluid">
                <div className="row">
                <div className="linesec">
                  <span className="line1">
                  </span>
                  <span className="line2">
                  </span>
                  <span className="line3">
                  </span>
                </div>
                  <div className="col-lg-8 sec1">
                      <div className="img-wrap" data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
                        <img src={bodycontimg3} alt="" className="img2"/>
                      </div>
                      <img src={bodycontimg4} alt="" className="img3" data-aos="fade-down" data-aos-delay="500"
        data-aos-duration="2000" data-aos-anchor-placement="top-bottom"/>
                      <img src={bodycontimg5} alt="" className="img4"/>
                  </div>
                  <div className="col-lg-4" data-aos="fade-zoom-in" data-aos-easing="ease-in-back"
     data-aos-delay="300" data-aos-duration="2000" data-aos-anchor-placement="top-bottom">
                      <p>The year is 2087. A profoundly advanced research center has made a world changing discovery. The ability to observe dreams. This new scientific breakthrough was astounding, challenging the limits of what was before believed possible and a monumental step in the psychological study of dream therapy. As all new scientific breakthroughs do, this became commercialized, capitalized and commonly used as a device known as a ‘Dream Catcher’.</p>
                      <p>Every time a dream was extracted into the catcher and observed a fraction of the subconscious manifested into reality. Soon this ‘Dream Essence’ became too much for the realms of reality to bind together and caused the boundaries between worlds, time and reality to slowly shift, crumbling until humanity was merged with the vast and unknown subconscious realm. A realm is known simply as... The Dreamland.</p>

                  </div>
                </div>

            </div>
        </div>
        <section className="body-cont2" id="dreamers-sec">
                  <div className="title"  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
                      <div className="img-sec">
                        <h6>02</h6>
                        <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                      </div>
                      <h2>
                      dreamers
                    </h2>
                      <div className="linesec">
                        <span className="line1">
                        </span>
                        <span className="line2">
                        </span>
                        <span className="line3">
                        </span>
                        <span className="line4">
                        </span>
                      </div>
                    </div>
            <div className="container-fluid">
              <div className="row">
                  <div className="col-lg-7">
                      <ul>
                          <li data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500"><img src={bodycontimg6} alt="" className="img1"/></li>
                          <li data-aos="fade-down" data-aos-delay="300"
        data-aos-duration="2000"><img src={bodycontimg7} alt="" className="img2"/></li>
                          <li data-aos="fade-down" data-aos-delay="500"
        data-aos-duration="2500"><img src={bodycontimg8} alt="" className="img3"/></li>
                      </ul>
                      <div className="row">
                          <div className="offset-lg-4 col-lg-8" data-aos="fade-zoom-in" data-aos-easing="ease-in-back"
     data-aos-delay="300" data-aos-duration="2000">
                                <p>Dreams, in essence, are a state of consciousness that occurs during sleep. During this state the brain can create sensations, thoughts and images from all areas of your subconscious and imagination. From this state of consciousness, Dreamers are born. </p>
                                <p>The Dreamers are a collection of 10,000 unique Genesis NFT’s. These Dreamers are a lot more than just an attractive PFP and awesome avatar. Dreamers personify ownership, innovation and the desire to construct a diverse and unique community-driven infrastructure. By owning a Dreamer, you become a voice and advocate to participate in the development and direction of this project. </p>
                                <p>Each and every detail, from minor to major, has been meticulously and vigorously hand illustrated and perfected by our artist. Without AI. </p>
                                <p>Immerse yourself within the Dreamland. Join our community and become a leader, collaborator and observer to what awaits us all in this superlunary world.</p>
                                <div className="button-area1">
                                    <a href="https://discord.com/invite/dreamlandgenesis" target="_blank" className="mint-but">Join the Community</a>
                                    <span>
                                    </span>
                                </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </section>

        <section className="rarity-cont" id="rarity-sec">
                  <div className="title"  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
                      <div className="img-sec">
                        <h6>03</h6>
                        <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                      </div>
                      <h2>
                      RARITY
                    </h2>
                      <div className="linesec">
                        <span className="line1">
                        </span>
                        <span className="line2">
                        </span>
                        <span className="line3">
                        </span>
                        {/* <span className="line4">
                        </span> */}
                      </div>
                      <img className="main-img" src={rarityimg1} alt="img" />
                    </div>
        <div className="container-fluid">
            <div className="row">
                    <div className="side-bar">
                        <ul>
                            <li>
                            <a href="#">10,000 <span>dreamers</span></a>
                            </li>
                            <li>
                            <a href="#">2255<span>traits</span></a>
                            </li>
                            <li>
                            <a href="#">15 <span>backgrounds</span></a>
                            </li>
                            <li>
                            <a href="#">499 <span>weapons</span></a>
                            </li>
                            <li>
                            <a href="#">49 <span>tails</span></a>
                            </li>
                            <li>
                            <a href="#">7 <span>bodies</span></a>
                            </li>
                            <li>
                            <a href="#">60 <span>eyes</span></a>
                            </li>
                            <li>
                            <a href="#">6 <span>mouths</span></a>
                            </li>
                            <li>
                            <a href="#">588 <span>clothes</span></a>
                            </li>
                            <li>
                            <a href="#">211 <span>masks</span></a>
                            </li>
                            <li>
                            <a href="#">480 <span>hair</span></a>
                            </li>

                            <li>
                            <a href="#">282 <span>helmets</span></a>
                            </li>
                            <li>
                            <a href="#">58 <span>extras</span></a>
                            </li>
                        </ul>
                    </div>
                    <div className="decp-sec">
                        <h3>BREAK THROUGH THE REALMS</h3>
                        <div className="wrap">
                        <h4>MANIFESTATION: INSOMNIACS</h4>
                        <h5>// Sleepless Hybrids (COMMON)</h5>
                        <p>Despite making up the bulk of dreamers, they are by no means ‘regular citizens’ any longer. Once, they lived regular 9-5 lives, struggling with the day-to-day trials and tribulations of society. Their nights - filled with dreams. Dreams of desires, childhood fantasies and dreams of a better place. Exposure to the Dream Essence awakened their long-lost childhood dreams and their longing to leave the real world.</p>
                            </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg2} alt="img" />
                                    <h4>POPULATION: <span>5788 (58%)</span></h4>
                                    <p>Insomniacs make up the bulk of the Dreamlands Dreamers. The weakest when it comes to manipulation of Dream essence but a semi-detachment that brings them closer to other realms and realities.
</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg3} alt="img" />
                                    <h4>Traits: <span></span></h4>
                                    <p>Mecha Helm Z91, </p>
                                    <p>Scarab Mask, Kibaku Fuda, </p>
                                    <p>Decimation, </p>
                                    <p>Tranquility</p>
                                    <br/>
                                    {/* <p> Backgrounds:</p>
                                    <p>Citrine, Azurite, & Jasper</p> */}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg4} alt="img" />
                                    <h5>DREAM ESSENCE ABILITY: <br/> <span>REDACTED</span></h5>

                                    {/* <p> Backgrounds:</p>
                                    <p>Citrine, Azurite, & Jasper</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="wrap">
                        <h4>MANIFESTATION: DAYDREAMERS</h4>
                        <h5>// Curious Hallucinators (UNCOMMON)</h5>
                        <p>Daydreamers and night-thinkers. Days spent lost in thought as their imaginations ruled their mind conjuring grand plans, fantastical stories and living out their wildest curiosities. Nights spent deep in thought, exploring the darker regions of their minds. Their ingenuity and creativity, already limitless, only exemplified by their interaction with the Dream Essence.</p>
                            </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg5} alt="img" />
                                    <h4>POPULATION: <span>3593 (36%)</span></h4>
                                    <p>Daydreamers fill the higher roles in Dreamer society. They’re stronger and more renowned then their insomniac subordinates but still far from reaching the heights of a Lucid Dreamer.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg6} alt="img" />
                                    <h4>Traits: <span></span></h4>

                                    <p>Angler</p>
                                    <p>Aldedo Mask</p>
                                    <p>TNT Ant</p>
                                    <p> Abyssal Trident</p>
                                    <p>Hellreaver</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg7} alt="img" />
                                    <h5>DREAM ESSENCE ABILITY: <br/> <span>REDACTED</span></h5>
                                </div>
                            </div>
                        </div>

                        <div className="wrap">
                        <h4>MANIFESTATION: LUCID DREAMERS</h4>
                        <h5>// Hopeless Fantasizers (RARE)</h5>
                        <p>Dream walkers, guides of the night and masters within their own dreams. Even before the breakdown of realms they lived double lives. Their day to day a blur but nights filled by fantasies and imagination as they commanded mighty armies from within their own fantasy realms. They are the embodiment of dreams and imagination, some of the strongest among the Dreamers and feel more at home in the Dreamland than their own realm.
</p>
                            </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg8} alt="img" />
                                    <h4>POPULATION: <span>599 (6%)</span></h4>
                                    <p>Champions, hero’s and leaders. Their control over the dream essence and abilities to manifest in the Dreamland let these Lucid Dreamers who choose as such to live lives of royalty and excess.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg9} alt="img" />
                                    <h4>Traits:</h4>

                                    <p>Exodus,</p>
                                    <p>Mempo</p>
                                    <p>X32-5-6T</p>
                                    <p> Crescent Moon</p>
                                    <p>Supremacy</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="wrap2">
                                    <img className="main-img" src={rarityimg10} alt="img" />
                                    <h5>DREAM ESSENCE ABILITY: <br/> <span>REDACTED</span></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>

        <section className="body-cont3" id="irregularities-sec">
            <picture>
                <source srcSet={mobbg3} media="(max-width: 767px)"/>
                <source srcSet={bodycontimg9}/>
                <img className="img1" src={bodycontimg9} alt="img" />
            </picture>

          <img className="img2" src={bodycontimg10} alt="img" />

          <div className="title-sec">
          <div className="linesec">
          </div>
            <h2>IRREGULARITIES</h2>
            <h4>Coming soon</h4>
          </div>
        </section>
        <section className="body-cont4" id="roadmap-sec">
        <div className="linesec">
        <span className="line1">
                        </span>
                        <span className="line2">
                        </span>
                        <span className="line3">
                        </span>
                        <span className="line4">
                        </span>
          </div>
              <div className="title"  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
                  <div className="img-sec">
                    <h6>03</h6>
                    <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                  </div>
                  <h2>
                  roadmap
            </h2>
                </div>
                <div className="container-fluid">
       <div className="row">
           <div className="col-lg-4"  data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500">
               <div className="row">
                   <div className="col-lg-6 col-6 p-0 sec1">
                      <img className="img2" src={bodycontimg11} alt="img" />
                   </div>
                   <div className="col-lg-6 col-6 sec2">
                       <h2>PHASE 1</h2>
                       <h3>HARBRINGER </h3>
                       <ul>
                           <li><i className="fas fa-circle"></i>Community </li>
                           <li><i className="fas fa-circle"></i>Launch </li>
                           <li><i className="fas fa-circle"></i>Dream house </li>
                       </ul>
                   </div>
               </div>
           </div>
           <div className="col-lg-4"  data-aos="fade-down" data-aos-delay="400"
        data-aos-duration="1500">
               <div className="row">
                   <div className="col-lg-6 col-6 p-0 sec1">
                   <img className="img2" src={bodycontimg12} alt="img" />
                   </div>
                   <div className="col-lg-6 col-6 sec2">
                       <h2>PHASE 2</h2>
                       <h3>SURREALISM  </h3>
                       <ul>
                           <li><i className="fas fa-circle"></i>Cosmic Comics </li>
                           <li> <i className="fas fa-circle"></i>Dream-Wares</li>
                           <li><i className="fas fa-circle"></i>Irregularities </li>
                       </ul>
                   </div>
               </div>
           </div>
           <div className="col-lg-4"  data-aos="fade-down" data-aos-delay="800"
        data-aos-duration="1500">
               <div className="row">
                   <div className="col-lg-6 col-6 p-0 sec1">
                   <img className="img2" src={bodycontimg13} alt="img" />
                   </div>
                   <div className="col-lg-6 col-6 sec2">
                       <h2>PHASE 3</h2>
                       <h3>WANDERLUST  </h3>
                       <ul>
                           <li><i className="fas fa-circle"></i>Dream Scholars</li>
                           <li><i className="fas fa-circle"></i>Nightmares </li>
                           <li><i className="fas fa-circle"></i>The Dreamland</li>
                       </ul>
                   </div>
               </div>
           </div>
           <div className="col-lg-12">
              <div className="button-area1"  data-aos="zoom-in" data-aos-delay="100"
        data-aos-duration="1500">
                      <a href="https://medium.com/dreamland-genesis/story-map-c7a064625b6f" target="_blank" className="mint-but">STORY MAP</a>
                      <span>
                      </span>
                  </div>
              </div>
       </div>
   </div>
          </section>

            <section className="body-cont5" id="vision-sec">

                <picture>
                <source srcSet={mobbg4} media="(max-width: 767px)"/>
                <source srcSet={bodycontimg14}/>
                <img className="img2" src={bodycontimg14} alt="img" />
                </picture>
                <div className="linesec">
                <span className="line1">
                        </span>
                        <span className="line2">
                        </span>
                        <span className="line3">
                        </span>
                        <span className="line4">
                        </span>
                </div>
                <div className="title"  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
                    <div className="img-sec">
                        <h6>04</h6>
                        <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                    </div>
                    <h2>
                    vision
            </h2>
                </div>
                <div className="wrap" data-aos="fade-zoom-in" data-aos-easing="ease-in-back"
     data-aos-delay="300" data-aos-duration="2000">
                <img className="img3" src={bodycontimg15} alt="img" />
                    <p>Our Vision ultimately revolves around empowering our community through innovation, collaboration and creating
                        mutually beneficial opportunities together. Our ambition is to launch a fully immersive, scalable NFT
                        project that will eventually evolve and branch off into other creative mediums. We aim to become forefront
                        leaders and innovators within the development of Web 3.0, fully equipped for mass adoption as it fast
                        approaches. </p>
                    <p>We believe in empowering the Dreamland community by integrating fellow Dreamers, utilizing our combined
                        skills and knowledge to further roadmap advancements within our dynamic ecosystem. Our venture within the
                        virtual space ultimately has one goal, forging The Dreamland Private Sanctuary – A Dreamers digital home.
                    </p>
                    <div className="button-area1">
                        <a href="https://medium.com/dreamland-genesis/our-dream-80d64ab518de" target="_blank" className="mint-but">Our Dream</a>
                        <span>
                        </span>
                    </div>
                </div>
            </section>

            <section className="body-cont6" id="team-sec">
                <div className="linesec">
                </div>
                <div className="title"  data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
                    <div className="img-sec">
                        <h6>05</h6>
                        <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                    </div>
                    <h2>
                    team
            </h2>

                </div>
                <div className="wrap" data-aos="fade-zoom-in" data-aos-easing="ease-in-back"
     data-aos-delay="300" data-aos-duration="2000">
                    <h6 data-aos="fade-left">Presenting the Dream Team,</h6>
                    <p>Between them they’re responsible for the destruction and merging of the dimensional boundaries. An act that has plunged humanity headfirst into a land with no clear divide.  </p>
                    <h6>A quick word from the Founders,</h6>
                    <p>Everyone’s had the same thoughts after, or during, watching anime, cartoons or movies. "I wish that world was real", "What if I was that character for a day?" and many more. People are infatuated and obsessed with fantasy worlds, that’s why we love them so much. Be it dressing up via cosplay, acting like them in video games, fan art and so much more. </p>
                    <p>We love, and are very much influenced by both western and Asian media. Therefore, inspired by this thought, we endeavoured to create a project that would reflect this and allow others, and ourselves, to relive the childish dreams they once had.</p>
                    <p>The incredible rise of NFT’s has proved to be an engine and a catalyst that has both inspired us and enabled us to construct a truly incredible project. A project with innovation, art, and utility – built alongside and for our community. </p>
                    <p>We’re a team of like-minded individuals and partners equally as passionate and invested into this project’s success. The Dream Team is made up of specialists in their respective fields, and together we are pleased to present you - The Dreamland Genesis Project.</p>
                </div>
                <ul className="sec1">
                    <li data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500">
                    <img className="img2" src={bodycontimg16} alt="img" />
                        <h2>BEN CHUCHU</h2>
                        <h4>Co-Founder, CEO</h4>
                        <p>A Dreamer at birth, an Entrepreneur in reality, a Creative at heart. </p>
                        <a href="https://twitter.com/benchuchuu" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li>
                    <li data-aos="fade-down" data-aos-delay="500"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg2} alt="img" />
                        <h2>JUSTIN</h2>
                        <h4>Co-Founder, COO </h4>
                        <p>Owned his first PC at 19 and lost in the digital world since then.   </p>
                        <a href="https://twitter.com/pixie_DG" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li>
                        {/*  
                    <li data-aos="fade-down" data-aos-delay="300"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg7} alt="img" />
                        <h2>jason </h2>
                        <h4>Creative Director</h4>
                        <p>An extremely vascular man, equipped with a muscular brain tuned for literary art.</p>
                        <a href="https://twitter.com/JasoNFT_" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li>*/}
                    
                </ul>

                <ul className="sec1">
                <li data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg9} alt="img" />
                        <h2>KENDRICK WONG</h2>
                        <h4>Advisor</h4>
                        <p>Forbes 30U30 Asia, Prestige 40U40, Co-founder of Alpha CW  ($200m USD Fund)</p>
                        {/* <a href="https://twitter.com/dr_metaversepal" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    <li data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg11} alt="img" />
                        <h2>GIULIO XILOYANNIS</h2>
                        <h4>Advisor</h4>
                        <p>ZALORA Co-Founder & CCO. Founding Investor for Omnilytics and an adviser for Musa, Taskomat and Edgar</p>
                        {/* <a href="https://twitter.com/dr_metaversepal" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    <li data-aos="fade-down" data-aos-delay="700"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg4} alt="img" />
                        <h2>zeneca</h2>
                        <h4>Advisor</h4>
                        <p>Founder of Zenacademy </p>
                        <a href="https://twitter.com/zeneca_33" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li>
                    <li data-aos="fade-down" data-aos-delay="700"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg12} alt="img" />
                        <h2>Joshua</h2>
                        <h4>Industrial Psychologist</h4>
                        <p>Prof. of Psychology, Industrial & Organisational Psychologist, Consultant for F500</p>
                        {/* <a href="https://twitter.com/zeneca_33" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    </ul>
                    <ul className="sec1">
                    <li data-aos="fade-down" data-aos-delay="700"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg10} alt="img" />
                        <h2>JARED</h2>
                        <h4>Tokenomics Strategist</h4>
                        <p>Harvard ‘18 BA Economics, Corporate Finance, Tokenomics Specialist</p>
                        {/* <a href="https://twitter.com/zeneca_33" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    <li data-aos="fade-down" data-aos-delay="700"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg13} alt="img" />
                        <h2>NATALASTE</h2>
                        <h4>CMO</h4>
                        <p>Ogilvy(PR), Heineken (Corporate Affairs), Binance (Strategy & NFT), Alethea (CM & Innovation)</p>
                        {/* <a href="https://twitter.com/zeneca_33" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    {/* <li data-aos="fade-down" data-aos-delay="100"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg6} alt="img" />
                        <h2>J.YAU</h2>
                        <h4>Programmer</h4>
                        <p>A Dr. in less than a year and a multilingual genius.  </p>
                        <a href="https://twitter.com/dr_metaversepal" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li> */}
                    {/* <li data-aos="fade-down" data-aos-delay="300"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg7} alt="img" />
                        <h2>jason </h2>
                        <h4>Chief Informations</h4>
                        <p>An extremely vascular man, equipped with a muscular brain tuned for literary art.</p>
                        <a href="https://twitter.com/JasoNFT_" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li> */}
                    {/* <li data-aos="fade-down" data-aos-delay="500"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg8} alt="img" />
                        <h2>Cpt. Magnolia   </h2>
                        <h4>Blockchain Engineer, Developer</h4>
                        <p>Ensuring your minting gas cost is low, you’re welcome ;)   </p>
                        <a href="#?" className="social-icon" target="_blank"></a>
                    </li> */}
                    <li data-aos="fade-down" data-aos-delay="700"
        data-aos-duration="1500">
                    <img className="img2" src={lusiimg} alt="img" />
                        <h2>LUIS FIGUEIREDO </h2>
                        <h4>Lead Comic Artist</h4>
                        <p>An artist well known in the comic space for his Anime/Manga themed art </p>
                        <a href="https://www.instagram.com/inkartluis/" className="social-icon" target="_blank"><i className="fab fa-instagram"></i></a>
                    </li>
                    <li data-aos="fade-down" data-aos-delay="300"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg5} alt="img" />
                        <h2>YEE HSIEN </h2>
                        <h4>Artist </h4>
                        <p>Quit his job for the Dreamland and will never turn back.</p>
                        <a href="https://twitter.com/dgnayshay" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li>
                    <li data-aos="fade-down" data-aos-delay="900"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg3} alt="img" />
                        <h2>Koo </h2>
                        <h4>Communications  </h4>
                        <p>A hard worker who lives for the incentive of growth</p>
                        {/* <a href="https://twitter.com/kleesgp" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a> */}
                    </li>
                    {/* <li data-aos="fade-down" data-aos-delay="900"
        data-aos-duration="1500">
                    <img className="img2" src={teamimg3} alt="img" />
                        <h2>Kent  </h2>
                        <h4>Corporate Advisor  </h4>
                        <p>A Technopreneur, biz savvy corporate professional, and full of Dreams!</p>
                        <a href="https://twitter.com/kleesgp" className="social-icon" target="_blank"><i className="fab fa-twitter"></i></a>
                    </li> */}
                </ul>
                <div className="button-area1">
                        <a href="/faq" className="mint-but">faq</a>
                        <span>
                        </span>
                    </div>
            </section>

            <section className="advocate-cont" id="advocate-sec">

                <div className="title"  data-aos="fade-down"
                 data-aos-easing="linear"
                 data-aos-duration="1500">
                    <div className="img-sec">
                        <h6>08</h6>
                        <div className="zebra-wrap">
                    <div className="holder">
                        <span className="line1 pos-line1"></span>
                        <span className="line1 pos-line2"></span>
                        <span className="line1 pos-line3"></span>
                        <span className="line1 pos-line4"></span>
                        <span className="line1 pos-line5"></span>
                        <span className="line1 pos-line6"></span>
                        <span className="line1 pos-line7"></span>
                        <span className="line1 pos-line8"></span>
                        <span className="line1 pos-line9"></span>
                        <span className="line1 pos-line10"></span>
                        <span className="line1 pos-line11"></span>
                        <span className="line1 pos-line12"></span>
                        <span className="line1 pos-line13"></span>
                        <span className="line1 pos-line14"></span>
                        <span className="line1 pos-line15"></span>
                        <span className="line1 pos-line16"></span>
                        <span className="line1 pos-line17"></span>
                        <span className="line1 pos-line18"></span>

                        <span className="line1 pos-line19"></span>
                        <span className="line1 pos-line20"></span>
                        <span className="line1 pos-line21"></span>
                        <span className="line1 pos-line22"></span>
                        <span className="line1 pos-line23"></span>
                        <span className="line1 pos-line24"></span>
                        <span className="line1 pos-line25"></span>
                        <span className="line1 pos-line26"></span>
                        <span className="line1 pos-line27"></span>
                        <span className="line1 pos-line28"></span>
                        <span className="line1 pos-line29"></span>

                        <span className="line1 pos-line30"></span>
                        <span className="line1 pos-line31"></span>
                        <span className="line1 pos-line32"></span>
                        <span className="line1 pos-line33"></span>
                        <span className="line1 pos-line34"></span>
                        <span className="line1 pos-line35"></span>
                        <span className="line1 pos-line36"></span>
                        <span className="line1 pos-line37"></span>
                        <span className="line1 pos-line38"></span>
                        <span className="line1 pos-line39"></span>
                        <span className="line1 pos-line40"></span>

                        <span className="line1 pos-line41"></span>
                        <span className="line1 pos-line42"></span>
                        <span className="line1 pos-line43"></span>
                        <span className="line1 pos-line44"></span>
                    </div>
                </div>
                    </div>
                    <h2>
                    COMMUNITY <span> TEAM</span>
                    </h2>
                    {/* <div className="sec1 img1">
                        <img className="" src={advocateimg1} alt="img" />
                        <h4>Capo9</h4>
                    </div>
                    <div className="sec1 img4">
                        <img className="" src={advocateimg1} alt="img" />
                        <h4>Devilsnarefizz</h4>
                    </div> */}


                    <img className="img2" src={advocateimg2} alt="img" />
                    <img className="img3" src={advocateimg3} alt="img" />
                    {/* <img className="img4" src={advocateimg4} alt="img" />   */}

                    <img className="img6" src={advocateimg6} alt="img" />
                </div>
                {/* <img className="img5" src={advocateimg5} alt="img" />  */}
                {/* <div className="sec1 img5">
                        <img className="" src={advocateimg1} alt="img" />
                        <h4>Calvinio</h4>
                    </div> */}
                <div className="button-area1">
                        <a href="/Dream" className="mint-but">Explore</a>
                        <span>
                        </span>
                    </div>
            </section>
            {/* </SmoothScroll> */}
    </div>
    <Footer/>
    </>
  );
};

export default Home;
